"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiFieldsSection = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _multiFieldsSectionModule = _interopRequireDefault(require("./multi-fields-section.module.scss"));
var MultiFieldsSection = function MultiFieldsSection(_ref) {
  var mainField = _ref.mainField,
    secondaryField = _ref.secondaryField,
    message = _ref.message,
    containerClassName = _ref.containerClassName,
    secondaryFieldClassName = _ref.secondaryFieldClassName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_multiFieldsSectionModule.default['multi-fields-section'], containerClassName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _multiFieldsSectionModule.default['multi-fields-section__main-field']
  }, mainField), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_multiFieldsSectionModule.default['multi-fields-section__secondary-field'], secondaryFieldClassName),
    "data-testid": "secondary-field"
  }, secondaryField), message && /*#__PURE__*/_react.default.createElement("div", {
    className: _multiFieldsSectionModule.default['multi-fields-section__message']
  }, message));
};
exports.MultiFieldsSection = MultiFieldsSection;